import React, { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../../../../../config";
import { useSelector } from "react-redux";
import Toast from "../../../../common/toast";
import { useNavigate, useLocation } from "react-router-dom";
import Spinner from "../../../../common/spinner";

const JobReviewRate = ({
  jobDetailsInfo,
  jobDetailId,
  jobRating,
  handleClosePopup,
  currentPage,
  fetchjobList,
  setCurrentPage,
  displayErrMsg,
  displaySuccessMsg,
  userEntityId,
  hiredCandidatesList,
  getHiredCandidatesList,
  getJobDetailsData,
  applicantListItem
}) => {
  const location = useLocation();
  const currentUrl = location.pathname;
  const [rating, setRating] = useState(jobRating ? jobRating : 0);
  const [review, setReview] = useState("");
  const { TOKEN, role_type } = useSelector((state) => state.menu);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });

  console.log("userEntityId====",userEntityId, applicantListItem)

  useEffect(() => {
    setRating(applicantListItem?.jobRating)
  }, [applicantListItem])

  const handleRating = (newRating) => {
    // if (jobRating === 0) {
      setRating(newRating);
    // }
  };

  const handleReviewChange = (e) => {
    setReview(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("handle submit", rating)
    if (rating === 0) {
      displayErrMsg("Rating is required");
      return;
    }

    setLoading(true);

    try {
      let url;
      if (role_type.includes("ROLE_USER")) {
        url = `${BASE_URL}jobs/${jobDetailId}/reviewJob`;
      } else if (role_type.includes("ROLE_INSTITUTION_ADMIN")) {
        if (currentPage === "jobList") {
          url = `${BASE_URL}institutions/jobs/${jobDetailsInfo}/reviewJob`;
        } else if (currentPage === "approveFinish" || currentPage === "approveFinishIndividual") {
          if(applicantListItem?.jobFinished){
            url = `${BASE_URL}institutions/jobs/${jobDetailId}/updateReviewRating/${userEntityId}`;
          }else{
            // if(hiredCandidatesList?.length === 1){
            //   url = `${BASE_URL}institutions/jobs/${jobDetailId}/approveClockInClockOut`;
            //  }else{
            //   url = `${BASE_URL}institutions/jobs/${jobDetailId}/approveClockInClockOut/${userEntityId}`;
            //  }
            url = `${BASE_URL}institutions/jobs/${jobDetailId}/finishJob/${userEntityId}`;
          }
          
        }
      }

      const config = {
        headers: {
          Accept: "*/*",
          Authorization: `Bearer ${TOKEN}`,
        },
      };

      const formData = {
        // nStars: rating,
        review: review,
      };

      if(applicantListItem?.jobFinished){
        formData.numStars = rating;
      }else{
        formData.nStars = rating;
      }

      let response = "";

      if (role_type.includes("ROLE_USER")) {
        response = await axios.post(url, formData, config);
        console.log("response:::::", response);
      } else if (role_type.includes("ROLE_INSTITUTION_ADMIN")) {
        if (currentPage === "jobList") {
          response = await axios.post(url, formData, config);
        } else if (currentPage === "approveFinish" || currentPage === "approveFinishIndividual") {
          response = await axios.put(url, formData, config);
        }
      }

      console.log("response========", response)
      if (response.status === 200) {
        displaySuccessMsg("Rating and review added successfully!");
        setIsLoading(false);
        setRating(0);
        setReview("");
        if (currentPage === "jobList") {
          setCurrentPage(1);
          fetchjobList();
        }else if(currentPage === "approveFinish" || currentPage === "approveFinishIndividual"){
          // getHiredCandidatesList();
          getJobDetailsData();
          
        }

        if(currentPage !== "approveFinishIndividual"){
          handleClosePopup();
        }
      } else {
        displayErrMsg(response?.response?.data?.message);
      }
    } catch (error) {
      console.log("error------", error);
      if (
        error?.response?.data?.errorMessage
      ) {
        displayErrMsg(error.response.data.errorMessage);
      } else {
        displayErrMsg("Something went wrong!");
      }
      // Clear state in case of error
      setRating(0);
      setReview("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={currentPage === "approveFinishIndividual" ? "mt-3 mb-3" : "container"}>
      <div className="row">
        <div className="col-md-12">
          <div className={currentPage !== "approveFinishIndividual" && "card"}>
            <div className={currentPage !== "approveFinishIndividual" && "card-body"}>
              <div style={{ display: "flex", gap: "10px" }}>
                {/* <h5 className="card-title">Review Rating:</h5> */}
                <b>Review Rating:</b>
                <div className="rating mb-3">
                  {[...Array(5)].map((_, index) => (
                    <i
                      key={index}
                      disabled={applicantListItem?.jobFinished}
                      className="fas fa-regular fa-star"
                      onClick={() => handleRating(index + 1)}
                      style={{
                        color: index < (applicantListItem?.jobRating ? applicantListItem?.jobRating : rating) ? "#128c5e" : "lightgrey",
                        cursor: "pointer",
                        position: "relative",
                        top: 0,
                      }}
                    />
                  ))}
                </div>
              </div>
              {
                (applicantListItem?.jobFinished && applicantListItem?.jobReview) ? (
                  <h5 className="card-title quote-container">
                    <i className="fas fa-quote-left quote-icon left"></i>
                    <span className="quote-text">
                      {applicantListItem?.jobReview}
                    </span>
                    <i className="fas fa-quote-right quote-icon right"></i>
                  </h5>
                ) : 
                (
                  <form>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      placeholder="Write a review"
                      value={review}
                      style={{
                        width: "100%",
                        padding: "20px",
                        border: "none",
                        height: "100px",
                        borderRadius: "10px",
                        backgroundColor: "#f0f6fe",
                        resize: "vertical",
                      }}
                      onChange={handleReviewChange}
                      // disabled={jobRating > 0}
                    ></textarea>
                  </div>
                  <button
                    type="button"
                    className={currentPage !== "approveFinishIndividual" ? "btn btn-success" : "site-button"}
                    // disabled={loading || jobRating > 0}
                    onClick={handleSubmit}
                    style={{ display: "block", margin: "0 auto", float: currentPage !== "approveFinishIndividual" ? "none" : 'right' }}
                  >
                    {loading ? <Spinner /> : "Submit"}
                  </button>
                </form>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobReviewRate;
